import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';

import { useAuth } from 'hooks';

const EXCLUDED_ACCOUNT_IDS = [5, 41, 100];
const CONSENT_POLL_INTERVAL = 500;
const CONSENT_POLL_TIMEOUT = 20000;

const analyticsConsentGiven = () => {
  const { enzuzoGtmConsentObj } = window;

  return (
    !!enzuzoGtmConsentObj && enzuzoGtmConsentObj.analytics_storage !== 'denied'
  );
};

const useHotjar = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user || EXCLUDED_ACCOUNT_IDS.includes(user.accountId)) return;

    if (analyticsConsentGiven()) {
      hotjar.initialize('3082741', '6');
      return;
    }

    // Enzuzo sets window.enzuzoGtmConsentObj asynchronously after its own
    // init completes, so consent may not exist yet when this effect runs.
    // Poll until it appears (or is granted mid-session) instead of bailing.
    let elapsed = 0;
    const intervalId = setInterval(() => {
      elapsed += CONSENT_POLL_INTERVAL;

      if (analyticsConsentGiven()) {
        hotjar.initialize('3082741', '6');
        clearInterval(intervalId);
      } else if (elapsed >= CONSENT_POLL_TIMEOUT) {
        clearInterval(intervalId);
      }
    }, CONSENT_POLL_INTERVAL);

    return () => clearInterval(intervalId);
  }, [user]);
};

export default useHotjar;
